import lib from '@/library'
import config from '@/config'

/**
 * Suspension data
 * @typedef {Object} KillswitchSuspension
 * @property {boolean} [is4prematch=false] - is this suspension for prematch
 * @property {boolean} [is4live=false] - is this suspension for live
 * @property {Array<string>} fosporttypes
 * @property {Array<string>} fosports
 * @property {Array<string>} fopricetypes
 * @property {Array<string>} fomarkettypes
 */

const state = {
  /** @type {Array<KillswitchSuspension>} */
  suspensions: [],
  suspensionsstats: { list: null, isloaded: false, periodicfetchid: null, periodicfetchts: 0 }
}

const getters = {
  getSuspensions (state) { return state.suspensions },
  getSuspensionsStats (state) { return state.suspensionsstats },
  getFetchIsEnabled (state) { return config.app.autoconf.KILLSWITCH_PERIODIC_REFRESH_INTERVAL >= 30 },
  getFetchPeriodicDelay (state) {
    let periodicdelay = 1800
    if (config.app.autoconf.KILLSWITCH_PERIODIC_REFRESH_INTERVAL >= 30) {
      periodicdelay = config.app.autoconf.KILLSWITCH_PERIODIC_REFRESH_INTERVAL
      if (periodicdelay > 1800) { periodicdelay = 1800 }
    }
    return periodicdelay
  }
}

const actions = {
  fetchSuspensions (context, data = {}) {
    let suspstats0 = context.getters['getSuspensionsStats']
    let fetchIsEnabled = context.getters['getFetchIsEnabled']
    let fetchPeriodicDelay = context.getters['getFetchPeriodicDelay']
    let isperiodicfetch = data !== null && data.isperiodicfetch === 'yes'
    let now = Date.now()

    if (!fetchIsEnabled) {
      return // suspensions fetch is diabled
    }
    if (!isperiodicfetch && suspstats0.periodicfetchts > (now - ((fetchPeriodicDelay - 5) * 1000))) {
      return // do not call again if this is before the periodic delay interval expiry; this should ensure proper first (init) and wakeup/periodic calls
    }

    window.clearTimeout(suspstats0.periodicfetchid)
    context.commit('setSuspensionsStats', { periodicfetchts: now })

    let params = { list: 'ALL' }

    // if (params.list === 'ALL') { // dummy catch to disable call; TODO - remove
    //  // context.commit('setSuspensions', { suspensions: [], suspensions4fosporttypes: ['GOLF', 'NFL', 'BASKETBALL', 'BASEBALL'], suspensions4fosports: [], suspensions4fopricetypes: [], suspensions4fmarkettypes: [] })
    //  // context.commit('setSuspensions', { suspensions: [], suspensions4fosporttypes: [], suspensions4fosports: [], suspensions4fopricetypes: ['CP', 'SGM'], suspensions4fmarkettypes: [] })
    //  // context.commit('setSuspensions', { suspensions: [], suspensions4fosporttypes: [], suspensions4fosports: [], suspensions4fopricetypes: [], suspensions4fmarkettypes: ['93904.1'] })
    //  // context.commit('setSuspensions', { suspensions: [], suspensions4fosporttypes: [], suspensions4fosports: [], suspensions4fopricetypes: [], suspensions4fmarkettypes: [] })
    //  context.commit('setSuspensionsStats', { list: params.list, isloaded: true })
    //  let periodicfetchid = window.setTimeout(() => { context.dispatch('fetchSuspensions', { isperiodicfetch: 'yes' }) }, fetchPeriodicDelay * 1000)
    //  context.commit('setSuspensionsStats', { periodicfetchid: periodicfetchid })
    //  return
    // }

    return lib.kansas.psbetsuspension(
      params
    ).then(response => {
      let suspensionsNorm = []
      let suspensions = response.data.betsuspensions || []
      suspensions.forEach(suspension => {
        /** @type KillswitchSuspension */
        let suspensionNorm = { is4prematch: false, is4live: false, fosporttypes: [], fosports: [], fopricetypes: [], fomarkettypes: [] }
        if (typeof suspension.islive === 'undefined' || suspension.islive === null) {
          suspensionNorm.is4prematch = true
          suspensionNorm.is4live = true
        } else if (suspension.islive === -1) {
          suspensionNorm.is4live = true
        } else if (suspension.islive === 0) {
          suspensionNorm.is4prematch = true
        }

        if (suspension.fosporttypelist && Array.isArray(suspension.fosporttypelist)) { suspensionNorm.fosporttypes = suspension.fosporttypelist }
        if (suspension.fosportlist && Array.isArray(suspension.fosportlist)) { suspensionNorm.fosports = suspension.fosportlist }
        if (suspension.fopricetypelist && Array.isArray(suspension.fopricetypelist)) { suspensionNorm.fopricetypes = suspension.fopricetypelist }
        if (suspension.fomarkettypelist && Array.isArray(suspension.fomarkettypelist)) { suspension.fomarkettypelist.forEach((mt) => { suspensionNorm.fomarkettypes.push(mt + '') }) }
        suspensionsNorm.push(suspensionNorm)
      })
      context.commit('setSuspensions', { suspensions: suspensionsNorm })
      context.commit('setSuspensionsStats', { list: params.list, isloaded: true })

      let periodicfetchid = window.setTimeout(() => {
        context.dispatch('fetchSuspensions', { isperiodicfetch: 'yes' })
      }, fetchPeriodicDelay * 1000)

      context.commit('setSuspensionsStats', { periodicfetchid: periodicfetchid })
    }).catch(() => {
      context.commit('setSuspensions', [])

      let periodicfetchid = window.setTimeout(() => {
        context.dispatch('fetchSuspensions', { isperiodicfetch: 'yes' })
      }, fetchPeriodicDelay * 1000)

      context.commit('setSuspensionsStats', { list: params.list, isloaded: true, periodicfetchid: periodicfetchid })
    })
  }
}

const mutations = {
  setSuspensions (state, data) {
    state.suspensions = data.suspensions || []
  },
  setSuspensionsStats (state, data) {
    if (typeof data.list !== 'undefined') { state.suspensionsstats.list = data.list }
    if (typeof data.isloaded !== 'undefined') { state.suspensionsstats.isloaded = data.isloaded }
    if (typeof data.periodicfetchid !== 'undefined') { state.suspensionsstats.periodicfetchid = data.periodicfetchid }
    if (typeof data.periodicfetchts !== 'undefined') { state.suspensionsstats.periodicfetchts = data.periodicfetchts }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/killswitch.js